var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 242,
    viewBox: "0 0 220 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-57.7025 150.803C-44.791 172.137 -16.9259 178.902 4.53606 165.913C16.0095 158.97 -10.16 137.203 -7.80358 125.038C-5.75219 114.447 26.027 113.695 20.018 103.766C7.10648 82.4321 -20.7587 75.6668 -42.2206 88.6556C-63.6825 101.644 -70.614 129.469 -57.7025 150.803Z",
    fill: "#C7DDC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.4 118.626C83.3609 129.104 69.9357 159.518 80.4139 186.557C86.0156 201.012 116.255 175.51 129.69 180.612C141.386 185.053 135.761 221.42 148.345 216.543C175.384 206.065 188.809 175.651 178.331 148.612C167.853 121.573 137.439 108.148 110.4 118.626Z",
    fill: "#C7DDC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.911 61.7229C59.5045 46.1099 31.1155 49.1851 15.5024 68.5916C7.15573 78.9663 39.1122 90.5075 41.0874 102.692C42.807 113.3 13.3393 124.734 22.3711 132C41.7777 147.613 70.1666 144.538 85.7797 125.132C101.393 105.725 98.3175 77.336 78.911 61.7229Z",
    fill: "#C7DDC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0038 281.84C92.8454 270.275 107.662 236.709 96.0978 206.868C89.9156 190.914 56.5422 219.06 41.7145 213.43C28.8061 208.528 35.0142 168.391 21.1258 173.774C-8.71581 185.338 -23.5325 218.904 -11.9682 248.746C-0.40397 278.587 33.1621 293.404 63.0038 281.84Z",
    fill: "#C7DDC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavListIcon);
export default __webpack_public_path__ + "static/media/NavListIcon.96e1d6063688c00bbebc0dcff1426f0b.svg";
export { ForwardRef as ReactComponent };